import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';
import { PeopleTableColumns } from './-table/type';
import { PeopleWorkerTypeFilter } from './-types';

/**
 * People画面の検索パラメータスキーマ
 */
export const PeopleTableFilterSchema = z.object({
  sortOrder: z.nativeEnum(OrderDirection).default(OrderDirection.ASC).optional(),
  sortColumn: z.enum([PeopleTableColumns.PERSON]).optional(),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  workerType: z.nativeEnum(PeopleWorkerTypeFilter).default(PeopleWorkerTypeFilter.EMPLOYEE),
  freeText: z.string().optional()
});
export type PeopleTableFilterSchema = z.infer<typeof PeopleTableFilterSchema>;